import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, ViewChild, AfterViewInit, input } from '@angular/core';
import { AbstractControl, FormControl, ReactiveFormsModule } from '@angular/forms';

// If you are wrapping this component in a way that makes it not a sibling of itself,
// remember to add .ice-radio-list-item-wrapper to the parent element of this component.
@Component({
  selector: 'app-ice-radio-list-item',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './ice-radio-list-item.component.html',
  styleUrl: './ice-radio-list-item.component.scss',
})
export class IceRadioListItemComponent implements AfterViewInit {
  @Input({ required: true }) label: string;
  @Input({ required: true }) value: string | number | boolean;
  @Input({ required: true }) control: AbstractControl;
  @Input() disabled: boolean = false;
  testId = input.required<string>();

  @ViewChild('checkboxInput') checkboxInput: ElementRef;

  constructor() {}

  get formControl(): FormControl {
    return this.control as FormControl;
  }

  ngAfterViewInit(): void {
    const input = this.checkboxInput.nativeElement as HTMLInputElement;
    if (this.disabled) {
      input.disabled = true;
    }
  }
}
